// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sign_up_ask_phone-module__container--2ZscX{-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}\n", ""]);
// Exports
exports.locals = {
	"container": "sign_up_ask_phone-module__container--2ZscX"
};
module.exports = exports;
